import { ORM } from './../engine/orm';
import { IMediated, IRunnable, IQuery, ITypedQuery, mediated_data_types } from 'core-ts-types';
import * as _4 from 'lodash';

const QUERY_KEY = `__queries__`;

export abstract class Query<T> implements ITypedQuery<T> {

  protected _result: T;

  constructor(...sources: (IMediated | mediated_data_types)[]) {
    this.register(...sources);
  }

  abstract run(): this;

  get result(): T {
    return this._result;
  }

  /**
   *
   * @param sources
   */
  register(...sources: (IMediated | mediated_data_types)[]) {
    Query.registerQuery(this, ...sources);
  }

  /**
   * @param query query that needs to execute in response to a command
   * @param sources {Array} all sources
   */
  static registerQuery (query: (IQuery | ITypedQuery<any>), ...sources: (IMediated | mediated_data_types)[]) {
    _4.each(sources, (source: IMediated): void => {
      source[QUERY_KEY] = source[QUERY_KEY] || [];
      source[QUERY_KEY]!.push(query);
    });

    return query.run();
  }
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-orm/dist/types/query.ts